/** `validateSearch` of /mieter: status (current|past|all), property (id), q, page. @param {Record<string, unknown>} search */
export function tenancySearch(search) {
  const status = typeof search.status === 'string' && ['past', 'all'].includes(search.status) ? search.status : undefined;
  const property =
    typeof search.property === 'number' || (typeof search.property === 'string' && /^\d+$/.test(search.property)) ? String(search.property) : undefined;
  const q = typeof search.q === 'string' && search.q.trim() !== '' ? search.q : undefined;
  const page = Number.isInteger(Number(search.page)) && Number(search.page) > 1 ? Number(search.page) : undefined;
  return { status, property, q, page };
}
